
import React, {Fragment,useState, useEffect} from 'react'
import axios from 'axios';
import { useHistory } from "react-router-dom";

export const Moderacion = (props) => {
    let valtotal =""
    const [messageLogin, setmessageLogin] = useState('Introduce tus datos para iniciar sesión');
    const [data, setData] = useState(null);
    const [userData, setUserData] = useState(null);
    const [userPass, setUserPass] = useState(null);
    const [isadminlogin, setIsAdminLogin] = useState(null);
    const [idevento, setIdevento] = useState(-1);
    const [ideventoavisos, setIdeventoAvisos] = useState(-1);
    const [idhiloeventoavisos, setIdhiloeventoAvisos] = useState(-1);
    const [txtaviso, setTxtAviso] = useState(-1);
  
    const userChange = (val) => {
        setUserData(val.target.value)
    }
    const passChange = (val) => {
        setUserPass(val.target.value)
    }
    const [listaEventos, setListaEventos] = useState(false)
    const fetchListaEventos = async () => {
      let dataFormEventos = {  
          "formato": "home_adnpymes",
          "idUsuario":  sessionStorage.getItem('adminmoderacion-idu')
         
      }
      
      let axiosConfig = {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization':`Bearer ${sessionStorage.getItem('adminmoderacion-token')}`
          },  
      };
      axios.post(`${process.env.REACT_APP_URL_API}formatos/obtenerformato`, dataFormEventos, axiosConfig)
      .then((res) => {
          console.log('Lista eventos::',res.data.data)
          setListaEventos(res.data.data)
          
      })
      .catch((err) => {
         props.removeAuth()
      }) 
    }

    useEffect(() => {
        fetchListaEventos();
    },[])
    const fetchDataEvento = async (ideventoseleccionado) => {
        let urlApi = `${process.env.REACT_APP_URL_API}formatos/obtenerformato`
        
        let dataFormEventos = {  
            "formato": "evento_hijo",
            "idUsuario": sessionStorage.getItem('adminmoderacion-idu'),
            "idEvento": ideventoseleccionado
        }
        let axiosConfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':`Bearer ${sessionStorage.getItem('adminmoderacion-token')}`
            },  
        };
            
        axios.post(urlApi, dataFormEventos, axiosConfig)
        .then((res) => {            
            console.log('DATA EVENTO SELECCINADO:',res.data.data)
            res.data.data.map(item =>{
                if(item.idZona === 4 &&   item.tipoZona == 'chat_preguntas'){
                   
                    setIdhiloeventoAvisos(item.valorWidget)

                }
            }
            )
        })
        .catch((err) => {
            console.log('ERROR',err)
          //  props.isAuth && props.removeAuth()
        }) 
    }

    const fetchLogin = () => {
        let urlApi = `${process.env.REACT_APP_URL_API}auth/LoginMail`
        let dataFormEventos = {  
            "email":userData,
            "password": userPass

        }
        let axiosConfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':`Bearer ${sessionStorage.getItem('adminmoderacion-token')}`
                
            },  
        };
        axios.post(urlApi, dataFormEventos, axiosConfig)
        .then((res) => {
            console.log("LOGIN MODERACION",res.data.data)
            sessionStorage.setItem('adminmoderacion','12wsd3456tgf')
            sessionStorage.setItem('adminmoderacion-token',res.data.data.token)
            sessionStorage.setItem('adminmoderacion-idu',res.data.data.idUsuario)
            sessionStorage.setItem('adminmoderacion-nombre',res.data.data.nombre)
            setIsAdminLogin(true)
        })
        .catch((err) => {
            console.log('ERROR',err.response)
            console.log('ERROR',err.message)
        })
       
    }
    const updateAviso = (val) => {
        if(val.target.value !== null){
            setTxtAviso(val.target.value.replace(/\n/g, "<br />"))
        }
        
    }

    const changeEventAvisos = async (e) => {
      
        setIdeventoAvisos(e.target.value);
        fetchDataEvento(e.target.value)
   
    };
    const updateAsk = (val) => {
       
        if(val !== undefined){
            valtotal = val.replace(/\n/g, "<br />");
        }
        
    }
    const responder = (val,hilo) => {
       
        valtotal = ''
        var list = document.getElementsByClassName("respuestaTextarea")
        for (var i = 0; i < list.length; i++) {
            list[i].remove()
        }
        var list = document.getElementsByClassName("botonTextarea")
        for (var i = 0; i < list.length; i++) {
            list[i].remove()
        }
        
        var element = document.createElement("textarea")
        element.className = 'respuestaTextarea'
        element.name = 'message'
        element.cols = 30
        element.rows = 5
        element.value =  ''
        element.onkeyup = function(){
            updateAsk(this.value)
          };
        var button = document.createElement('button')
        button.className = 'botonTextarea'
        button.innerHTML = "Guardar Respuesta"
        button.onclick = function(){
            saveChange(valtotal,val,hilo);return false;
          };
        document.getElementById('txtareaid-'+val).appendChild(element)
        document.getElementById('txtareaid-'+val).appendChild(button) 
        
    }

    const  enviarAviso = async () => {
        if(ideventoavisos == '-1'){
            alert('Seleccione un evento para enviar el mensaje global')
            return
        }
       
       let urlApi = `${process.env.REACT_APP_URL_API}hilos/AltaPost`
        let dataFormEventos = {  
            "idEvento": ideventoavisos,
            "idHilo": idhiloeventoavisos,
            "idUsuario": sessionStorage.getItem('adminmoderacion-idu'),
            "idPostPadre": 0,
            "nombreUsuario": sessionStorage.getItem('adminmoderacion-nombre'),
            "publico": 1,
            "texto": txtaviso

        }
        let axiosConfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':`Bearer ${sessionStorage.getItem('adminmoderacion-token')}`
            },  
        };
        axios.post(urlApi, dataFormEventos, axiosConfig)
        .then((res) => {
            console.log('enviar global::',dataFormEventos)
            alert('mensaje global enviado')
            fetchData()
        })
        .catch((err) => {
            console.log('ERROR',err.response)
            console.log('ERROR',err.message)
        })
        
    };

    const saveChange = async (val,idpregunta,idhilo) => {
        let urlApi = `${process.env.REACT_APP_URL_API}hilos/AltaPost`
        let dataFormEventos = {  
            "idEvento": idevento,
            "idHilo": idhilo,
            "idUsuario": sessionStorage.getItem('adminmoderacion-idu'),
            "idPostPadre": idpregunta,
            "nombreUsuario": sessionStorage.getItem('adminmoderacion-nombre'),
            "publico": 0,
            "texto": val
        }
        let axiosConfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':`Bearer ${sessionStorage.getItem('adminmoderacion-token')}`
            },  
        };
        axios.post(urlApi, dataFormEventos, axiosConfig)
        .then((res) => {
            console.log('preguntas moderacion::',res.data.data)
        var list = document.getElementsByClassName("respuestaTextarea")
        for (var i = 0; i < list.length; i++) {
            list[i].remove()
        }
        var list = document.getElementsByClassName("botonTextarea")
        for (var i = 0; i < list.length; i++) {
            list[i].remove()
        }
            fetchData()
        })
        .catch((err) => {
            console.log('ERROR',err.response)
            console.log('ERROR',err.message)
        })
    }

    const  changePreguntas =  (e) => {
        console.log((e.target.value))
        setIdevento(e.target.value);
        if(e.target.value == '-1'){
            setData(null)
        }
    };

    const fetchData = async () => {
        if(isadminlogin){
        let urlApi = `${process.env.REACT_APP_URL_API}hilos/PostModeradorEvento`
        let dataFormEventos = {  
            "idEvento": idevento,
        }
        let axiosConfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':`Bearer ${sessionStorage.getItem('adminmoderacion-token')}`
            },  
        };
        axios.post(urlApi, dataFormEventos, axiosConfig)
        .then((res) => {
            console.log('preguntas moderacion::',res.data.data)
            setData(res.data.data)
        })
        .catch((err) => {
            setData(null)
            console.log('ERROR',err.response)
            console.log('ERROR',err.message)
        })
        }
        
    };

    useEffect(() => {
        fetchData();
    },[idevento]);
    
    useEffect(() => {
        const interval = setInterval(() => {
          console.log('This will run every 30second!');
          //console.log(idevento)
          fetchData();
        }, 30000);
        return () => clearInterval(interval);
      }, [idevento]);

    if(sessionStorage.getItem('adminmoderacion') !== null){
        isadminlogin !== true &&   setIsAdminLogin(true)
    }
      
    if(isadminlogin && !listaEventos){ return  (<div></div>)}
    if(!isadminlogin){ return  (
        <Fragment>
            <div className="moderacion">
                <div className="container">
                    <div className="formContainer">
                        <form>
                            <div className="MesssageLogin">{messageLogin}</div>
                            <input className="input-form" type="text" id="nameLogin" name="nameLogin" placeholder="Usuario (email)" onChange={ userChange } />
                            <input className="input-form" type="password" id="passLogin" name="passLogin" placeholder="Contraseña" onChange={passChange} />
                            <div className="col">
                                <button className="btn btn-gris" type="button" onClick={fetchLogin}>Iniciar sesión</button>
                            </div>
                        </form>
                    </div>
                </div> 
            </div>
        </Fragment> 
    )}else{
        return  (
        <Fragment>
            <div className="moderacion">
                <div className="container">
                    <h4>Enviar mensaje global</h4>
                    <select id="avisos" onChange={(e) => {changeEventAvisos(e)}} value={ideventoavisos}>
                        <option value="-1">Seleccione un evento</option>
                        {
                            listaEventos.map(item =>
                            <Fragment key={Math.random() * 57005}>
                            {item.idZona === 2 && 
                                
                                    <Fragment >
                                    { item.eventosInscritos.map(evento =>
                                        <option key={Math.random() * 57005} value={evento.idEvento}>{evento.idEventoNavigation.nombre}</option>
                                    )}
                                    </Fragment>           
                               
                            }
                            </Fragment>
                            )
                        }
                            
                    </select>
                    <textarea name="textarea2" rows="5" cols="60" onChange={(e) => {updateAviso(e)}} ></textarea>
                    <button className="btn btn-primary" onClick={(e) => {enviarAviso()}} >Enviar mensaje global</button>
                    <div><hr/></div>
                </div>
                <div className="container">
                    <h4>Preguntas</h4>
                    <select id="preguntas" onChange={(e) => {changePreguntas(e)}} value={idevento}>
                        <option value="-1">Seleccione un evento</option>
                        {
                            listaEventos.map(item =>
                            <Fragment key={Math.random() * 57005}>
                            {item.idZona === 2 && 
                                
                                    <Fragment >
                                    { item.eventosInscritos.map(evento =>
                                        <option key={Math.random() * 57005} value={evento.idEvento}>{evento.idEventoNavigation.nombre}</option>
                                    )}
                                    </Fragment>           
                               
                            }
                            </Fragment>
                            )
                        }
                            
                    </select>{console.log('data es::',data)}

                    {data !== null &&
                    <div className="preguntasModeracion">
                        {
                            data
                            .filter(item => item.idPostPadre == 0 )
                            .map(item => 
                                <div className='itemPregunta'>{console.log('item pregunta::',item)}
                                    <div className='nombrePregunta'>
                                        {item.nombreUsuario} - {item.idUsuarioNavigation.email}
                                    </div>
                                    <div className="fechaPregunta">{new Date(item.fechaCreacion).toLocaleString('es-Es')}</div>
                                    <div className="textoPregunta">{item.texto}</div>
                                    <div className="respuesta" id={`txtareaid-${item.idPost}`}>
                                        {
                                        data
                                        .filter(respuesta => respuesta.idPostPadre == item.idPost )
                                        .map(respuesta => 
                                            <div className="textorespuesta">
                                                <div>RESPUESTA:</div> 
                                                <div>{respuesta.texto}</div>
                                            </div>
                                        )
                                        }    
                                    </div>
                                    <div>
                                        <div className='btnpreguntar btn btn-primary' onClick={() => {responder(item.idPost,item.idHilo)}} >Responder</div>
                                    </div>
                                        
                                    <div>
                                    
                                    </div>

                                </div>
                            )
                        }
                    </div>}
                </div> 
            </div>
        </Fragment> 
        )
    }
    
}
